import React from 'react';
import { ButtonWithFeedback } from 'widgets/Button';

import FormContext from './FormContext';
import msg from 'msg';

export default React.forwardRef((props, ref) => (
  <FormContext.Consumer>
    {formParams => (
      <ButtonWithFeedback
        {...props}
        ref={ref}
        successLabel={props.successLabel || msg.settings.buttons.saved}
        requestInProgress={formParams && formParams.requestInProgress}
        wasRequestSuccessful={formParams && formParams.wasRequestSuccessful}
      >
        {props.children || msg.settings.buttons.saveChanges}
      </ButtonWithFeedback>
    )}
  </FormContext.Consumer>)
);
